const Columns = [
    {
        id: "title",
        numeric: false,
        disablePadding: true,
        label: "Name",
        isSortable: true,
        gray:true,
    },
    {
        id: "description",
        numeric: false,
        disablePadding: true,
        label: "Description",
        isSortable: true,
        gray:true,
    },
    {
        id: "members",
        numeric: false,
        disablePadding: true,
        label: "Members",
        isSortable: true,
        gray:true,
    },
    { id: "action", numeric: false, disablePadding: true, label: "Action", rowclassName:"text-right", className:"text-right pr-30", gray:true, },
];

const ColumnsRes = [
    {
        id: "description",
        numeric: false,
        disablePadding: true,
        label: "Description",
        isSortable: true,
    },
    { id: "action", numeric: false, disablePadding: true, label: "Action", rowclassName:"text-right", className:"text-right pr-30" },
];
export { Columns, ColumnsRes };
  